import { 
    SET_FORM_PAX_DETAILS_VALID,
    SET_FORM_LEAD_PAX_DETAIS_VALID,
    SET_SIGNUP_PAX_FORM,
    SET_PAYMENT_FORM
} from './types';

export function SetPaxDetailsValid(value){
    return dispatch => dispatch({type:SET_FORM_PAX_DETAILS_VALID, payload:value});
}

export function SetLeadPaxDetailsValid(value){
    return dispatch => dispatch({type:SET_FORM_LEAD_PAX_DETAIS_VALID, payload:value});
}

export function SetSignUpPaxForm(value){
    return dispatch => dispatch({type:SET_SIGNUP_PAX_FORM, payload:value});
}

export function SetPaymentForm(value){
    return dispatch => dispatch({type:SET_PAYMENT_FORM, payload:value});
}


